export const REGIONS = [
  { value: 0, label: "수원", key: "suwon" },
  { value: 1, label: "의정부", key: "uijeongbu" },
  { value: 2, label: "홍천", key: "hongcheon" },
  { value: 3, label: "강릉", key: "gangneung" },
  { value: 4, label: "정선", key: "jeongseon" },
  { value: 5, label: "논산", key: "nonsan" },
  { value: 6, label: "충주", key: "chungju" },
  { value: 7, label: "보은", key: "boeun" },
  { value: 8, label: "예산", key: "yesan" },
  { value: 9, label: "광주", key: "gwangju" },
  { value: 10, label: "남원", key: "namwon" },
  { value: 11, label: "순천", key: "suncheon" },
  { value: 12, label: "전주", key: "jeonju" },
  { value: 13, label: "진주", key: "jinju" },
  { value: 14, label: "포항", key: "pohang" },
  { value: 15, label: "영주", key: "yeongju" },
  { value: 16, label: "진영", key: "jinyeong" },
  { value: 17, label: "대구", key: "daegu" },
];

export const KICT = [{ value: 18, label: "한국건설기술연구원", key: "kict" }];

export const ALL_REGIONS = [
  { value: 0, label: "수원", key: "suwon" },
  { value: 1, label: "의정부", key: "uijeongbu" },
  { value: 2, label: "홍천", key: "hongcheon" },
  { value: 3, label: "강릉", key: "gangneung" },
  { value: 4, label: "정선", key: "jeongseon" },
  { value: 5, label: "논산", key: "nonsan" },
  { value: 6, label: "충주", key: "chungju" },
  { value: 7, label: "보은", key: "boeun" },
  { value: 8, label: "예산", key: "yesan" },
  { value: 9, label: "광주", key: "gwangju" },
  { value: 10, label: "남원", key: "namwon" },
  { value: 11, label: "순천", key: "suncheon" },
  { value: 12, label: "전주", key: "jeonju" },
  { value: 13, label: "진주", key: "jinju" },
  { value: 14, label: "포항", key: "pohang" },
  { value: 15, label: "영주", key: "yeongju" },
  { value: 16, label: "진영", key: "jinyeong" },
  { value: 17, label: "대구", key: "daegu" },
  { value: 18, label: "한국건설기술연구원", key: "kict" },
];

export const ACCENT_COLOR = [
  "#534171", // accent-mulberry
  "#e97699", // accent-pink
  "#799cf0", // accent-blue
  "#f2b8bd", // accent-peach
  "#9783e8", // accent-violet
  "#dbbb8a", // accent-sand
  "#a9df8b", // accent-fresh
  "#59abf2", // accent-skyblue
  "#8656b3", // accent-purple
  "#fbd446", // accent-mango
  "#882b65", // accent-cherry
  "#2d9f83", // accent-green
  "#fbb32d", // accent-mandarin
  "#59c5be", // accent-mint
  "#ff7b7b", // accent-red
  "#abd20f", // accent-lime
  "#477bb8", // accent-navy
  "#43badb", // accent-bluegreen
  "#f69976", // accent-apricot
  "#074b12", // accent-forest
  "#d878e7", // accent-plum
  "#ffca0d", // accent-yellow
];
